query translations($original:String!, $homeLanguageIds:[ID]!) {
  translations(original:$original, homeLanguageIds:$homeLanguageIds) {
    original
    translation
    detectedLanguage {
      id
      name
    }
    homeLanguageId
  }
}
